import { memo } from 'react';
import { TableRow, TableCell } from '@mui/material';
import DataTableCell from './DataTableCell';
import clsx from 'clsx';
import styles from './styles.module.css';

function DataTableRow(props: any) {
    const {
        item,
        headers,
        onSelectRow,
        selected,
        selectedItemFromAction,
        columnWidths = [],
        getRowDisabled
    } = props;

    const isDisabledRow = getRowDisabled?.(item);
    return (
        <TableRow
            className={`${styles['datatable-rows']} ${isDisabledRow ? styles['row-disabled'] : ''}`}
            selected={
                item?.id !== undefined && selected?.id !== undefined
                    ? item.id === selected.id
                    : false
            }
        >
            {headers.map((header: any, subIndex: number) => {
                const isLastColumn = subIndex === headers.length - 1;
                const isStickyAction = props.isMobile && header?.type === 'action' && isLastColumn;
                const hasMaxWidth = header?.maxWidth !== undefined && header?.maxWidth !== '';

                let className = '';
                if (!hasMaxWidth) {
                    className = styles['datatable-tr-td-overflow'];
                } else {
                    className = styles['cell-with-max-width'];
                }

                return (
                    <TableCell
                        key={subIndex}
                        className={clsx(styles.cellBase, styles.wrapCell)}
                        align={header?.type === 'action' ? 'center' : header?.align || 'left'}
                        onClick={(e) =>
                            ['action', 'selection', 'presentation-options'].includes(header?.type)
                                ? header.onClick?.(e, item)
                                : onSelectRow?.(item)
                        }
                        sx={{
                            width: columnWidths[subIndex],
                            maxWidth: columnWidths[subIndex],
                            position: isStickyAction ? 'sticky' : 'static',
                            right: isStickyAction ? 0 : undefined,
                            backgroundColor: isStickyAction ? '#fcfcfc' : undefined,
                            minWidth: 0
                        }}
                    >
                        <DataTableCell
                            onSelectRow={onSelectRow}
                            header={header}
                            item={item}
                            index={subIndex}
                            selectedItemFromAction={selectedItemFromAction}
                            {...props}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
    );
}

export default memo(DataTableRow);
